import React, { useMemo, createContext, useContext } from 'react';
import { ChildrenBlockContext } from './ChildrenBlock.js';
import { BlockWrapperInstance } from './BlockWrapper.js';
export const BlockContext = createContext(undefined);
export function BlockRender() {
    const blockContext = useContext(BlockContext);
    const childrenContext = useContext(ChildrenBlockContext);
    const props = ({
        ...(blockContext?.attributes ?? {}),
        ...(childrenContext?.childrenProps ?? {}),
    });
    const Block = blockContext?.Block;
    if (!blockContext) {
        console.error('You tried to render a Smartfire Block without using BlockViewer or BlockEditor, we are missing a context here.');
        throw new Error('No block context available to render');
    }
    return React.createElement(BlockWrapperInstance, null,
        React.createElement(Block, { ...props }));
}
export function BlockViewer({ block: Block, childrenBlockRenderer: ChildrenBlockRenderer = undefined, children, }) {
    let viewer = function Viewer({ ...attributes }) {
        const blockId = useMemo(() => `View-${rawViewId++}`, []);
        return (React.createElement(BlockContext.Provider, { value: {
                id: blockId,
                Block,
                attributes,
                childrenBlockRenderer: ChildrenBlockRenderer,
                children,
            } },
            React.createElement(BlockRender, null)));
    };
    Object.defineProperty(viewer, 'name', { value: 'BlockViewer-' + (Block?.name ?? 'Raw') });
    return viewer;
}
let rawViewId = 0;
export const RawViewer = ({ children, childrenBlockRenderer, }) => {
    const blockId = useMemo(() => `Raw-${rawViewId++}`, []);
    return (React.createElement(BlockContext.Provider, { value: {
            id: blockId,
            Block: React.Fragment,
            attributes: {},
            childrenBlockRenderer,
        } }, children));
};

//# sourceMappingURL=BlockViewer.js.map
